import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {PearlHarbor} from "../PearlHarbor";
import {ScreenBounds} from "@nolimitcity/slot-launcher/bin/display/ScreenBounds";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {gsap, TimelineLite} from "gsap";
import {SpineTween} from "@nolimitcity/slot-game/bin/animation/SpineTween";
import {PearlHarborSoundManager} from "../sound/PearlHarborSoundManager";
import Spine = PIXI.spine.Spine;
import {PearlHarborHelper} from "../utils/PearlHarborHelper";
import {MathHelper} from "@nolimitcity/slot-game/bin/utils/MathHelper";

export class PearlHarborBackground extends PIXI.Container implements StageLayer {
    private _backgroundAnimation:PIXI.Container[];
    private _cockpit:Spine | null;
    private _mainGameAnimation:Spine | null;

    private _overlay:PIXI.Graphics;
    private _trackEntry:any;
    private _isIdling:boolean = false;

    private _startDelay:number = 15;
    private _intervalRange:[number, number] = [10, 30];
    private _idleTl:TimelineLite | null;
    constructor() {
        super();
        this.name = "BACKGROUND";
        this.init();
        this.onResize();
    }

    private createSpinEffect(name:string, x:number, y:number):PIXI.spine.Spine {
        const isNormal:boolean = (name === "mainBackgroundAnimation"),
            effect:PIXI.spine.Spine = new PIXI.spine.Spine(PearlHarbor.assetLoader.getSpineAsset(`${isNormal ? "main" : "freespin"}BackgroundAnimation`));
        effect.state.clearTracks();
        effect.name = name;
        effect.position.set(x, y);
        effect.visible = true;
        effect.autoUpdate = true;
        this._trackEntry = null;
        if(isNormal) {
            effect.state.setAnimation(0, "Idle-CloadsInAirA", true);
            effect.state.setAnimation(1, "Idle-CloadsInAirB", true);
            effect.state.setAnimation(2, "Idle_BackGroundPaning", true);
            effect.state.timeScale = 0.08;
        }

        return effect;
    }

    public updateCocpitIntensity(progress:number):void {
        if(!this._trackEntry) {
            return;
        }
        this._trackEntry.alpha = progress;
    }

    private init() {
        this._backgroundAnimation = [
            this.addNormalBGAnimation(),
            this.addFSBGAnimation()
        ];
    }

    private addNormalBGAnimation():PIXI.Container {
        const normalBgContainer:PIXI.Container = new PIXI.Container();
        normalBgContainer.name = "normalBgContainer";
        this._mainGameAnimation = this.createSpinEffect("mainBackgroundAnimation", 360, 360);
        normalBgContainer.addChild(this._mainGameAnimation);
        return normalBgContainer;
    }

    private addFSBGAnimation():PIXI.Container {
        const fsBgContainer:PIXI.Container = new PIXI.Container();
        fsBgContainer.name = "fsBgContainer";
        if(this._cockpit) {
            this._cockpit = null;
        }
        this._cockpit = this.createSpinEffect("freespinBackgroundAnimation", 360, 360);
        fsBgContainer.addChild(this._cockpit);
        return fsBgContainer;
    }

    public playCockpitAnimation(animationName:string):SpineTween {
        if(!this._cockpit) {
            debugger;
        }
        return new SpineTween(this._cockpit!, 1, animationName);
    }

    public playCockpitHitAnimation(stopThisRoundCounter:number):TimelineLite {
        if(!this._cockpit) {
            debugger;
        }
        if(stopThisRoundCounter === 0) {
            debugger;
        }
        const id = stopThisRoundCounter > 4 ? 4 : stopThisRoundCounter;
        let variant:number = Math.round(Math.random());
        const tl = gsap.timeline();
        if(id != 1){
            variant = 0;
        }
        tl.add([
            new SpineTween(this._cockpit!, 2, `hit_${id}${(variant === 0)? "":"_2"}`),
            () => {PearlHarborSoundManager.playSoundEffect(`fsHit_${id}${(variant === 0)? "":"_2"}`)}
        ]);
        return tl;
    }

    public playCockpitDamageAnimation(damagedMeterNum:number):void {
        if(!this._cockpit) {
            debugger;
        }
        if(damagedMeterNum < 4) {
            return;
        }
        const levels:number[] = [4, 8, 12, 15];
        let level:number = Math.floor((damagedMeterNum + 1) / 4) - 1;
        PearlHarborHelper.shakeScreen();
        this._cockpit!.state.setAnimation(3, `damage_${levels[level]}`, true);
    }

    public setMode(mode:string):void {
        const isFs:boolean = ((<string>mode).indexOf("FREESPIN") > -1),
            currentAnimationIndex:number = isFs ? 1 : 0;
        this.addChild(this._backgroundAnimation[currentAnimationIndex]);
        this._backgroundAnimation[currentAnimationIndex].visible = true;

        if(this._backgroundAnimation[1 - currentAnimationIndex].visible) {
            this.removeChild(this._backgroundAnimation[1 - currentAnimationIndex]);
        }
        if(isFs) {
            if(!this._cockpit) {
                debugger;
                return;
            }
            this._cockpit!.updateTransform();
            this._cockpit!.state.clearTracks();
            this._cockpit!.skeleton.setSlotsToSetupPose();
            this._cockpit!.skeleton.setToSetupPose();
            this._trackEntry = null;
            this._trackEntry = this._cockpit.state.setAnimation(5, "intensity", true);
            this._trackEntry.alpha = 0.2; // 0-1 value (percent)
            this._cockpit!.state.setAnimation(0, "loops", true);
            this._cockpit!.state.setAnimation(1, "flight", true);
        }
        //this.addChild(this._dimmer);
    }

    public onResize():void {
    }

    public startIdle():void {
        if(this._isIdling) {
            return;
        }

        this._isIdling = true;
        this._idleTl = gsap.timeline();
        this._idleTl.add(() => this.playIdleAnimation(), this._startDelay);
    }

    public stopIdle():void {
        this._isIdling = false;
        if(this._idleTl) {
            this._idleTl.pause();
            this._idleTl.kill();
        }

        this._idleTl = null;
    }

    private playIdleAnimation():void {
        if(!this._isIdling) {
            return;
        }

        if(!this._mainGameAnimation) {
            return;
        }

        this._mainGameAnimation.state.setAnimation(3, "noSpin-FlakFire", false);
        this._mainGameAnimation.state.setAnimation(4, "noSpin-MachineGunSweep", false);
        this._mainGameAnimation.state.setAnimation(5, "noSpin-burningZero", false);

        this._idleTl = gsap.timeline();
        this._idleTl.add(() => this.playIdleAnimation(), MathHelper.randomNumberInRange(this._intervalRange[0], this._intervalRange[1], 2));
    }
}